export const SET_USER_PREFERENCES_REQUEST = 'SET_USER_PREFERENCES_REQUEST';
export const SET_USER_PREFERENCES_SUCCESS = 'SET_USER_PREFERENCES_SUCCESS';
export const SET_USER_PREFERENCES_FAILED = 'SET_USER_PREFERENCES_FAILED';
